// extracted by mini-css-extract-plugin
export default {"loading":"loader_loading__Gsn7O","spin":"loader_spin__1yaMS"};